import { Grid, Typography } from '@mui/material';
import styles from '../ServicesMenu/services.module.scss'
import CONSTANTS from '../../config/constants.json';

const HumanServicesContactus = () => {
    const contactus = (): React.ReactElement => {
        const email = "suman1218@yahoo.com";
        return (
            <>
                <div className={styles.cardContainer}>
                    <Typography className={styles.header}>
                        Contact us
                    </Typography>
                    <div className={styles.content}>
                        <Typography>Please feel free to contact any one of the following individuals regarding Human Services activities:</Typography>
                    </div>
                    <Grid>
                        <div>
                            <Typography className={styles.secondcontent}>
                                Usha Ramaswamy (Board Liaison)
                            </Typography>
                        </div>
                        <div className={styles.secondcontent}>
                            <Typography className={styles.properspace}><img src='/images/phone-call.svg' className={styles.iconsstyles} />408-421-5647</Typography>
                            <Typography className={styles.properspace}><img src='/images/ic_sharp-email.svg' className={styles.iconsstyles} />uvrsolutions@gmail.com</Typography>
                        </div>
                    </Grid>
                    <Grid>
                        <div>
                            <Typography className={styles.secondcontent}>Shyamala Venkateswaran (EC chair Human Services)</Typography>
                        </div>
                        <div className={styles.secondcontent}>
                            <Typography className={styles.properspace}><img src='/images/phone-call.svg' className={styles.iconsstyles} /> 408-375-4684</Typography>
                            <Typography className={styles.properspace}><img src='/images/ic_sharp-email.svg' className={styles.iconsstyles} />ec_human_services@{CONSTANTS.DOMAIN_NAME}</Typography>
                        </div>
                    </Grid>
                    <Grid>
                        <div >
                            <Typography className={styles.secondcontent}>Suman Jain (Member)</Typography>
                        </div>
                        <div className={styles.secondcontent}>
                            <Typography className={styles.properspace}><img src='/images/phone-call.svg' className={styles.iconsstyles} />925-371-5640</Typography>
                            <Typography className={styles.properspace}><img src='/images/ic_sharp-email.svg' className={styles.iconsstyles} /><a href={`mailto:${email}`} className={styles.email}>{email}</a></Typography>
                        </div>
                    </Grid>
                </div>
                <div className={styles.positioncontent}>
                    <a href={CONSTANTS.DOMAIN_URL +"/hints/content/html/2022/hccc-human-services1.pdf"}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}>
                        <Grid className={styles.download}>
                            <div className={styles.imageposition}>

                                <div className={styles.positionicon}>
                                    <img src='/images/Ellipse_broucher.svg' />
                                    <img src='/images/download_broucher.svg' className={styles.downloadicon} />
                                </div>
                                <Typography className={styles.downloadtext}> Download the
                                    Brochure</Typography>

                            </div>

                        </Grid>
                    </a>
                    <a href="https://www.independentnews.com/community/grant-in-aid-program-provides-funds-to-organizations/article_0adc3c3e-50db-11e9-b75f-4307439d4936.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}>
                        <Grid className={styles.downloadbroucher}>
                            <div className={styles.imageposition}>
                                <div className={styles.positionicon}>
                                    <img src='/images/Ellipse_broucher.svg' />
                                    <img src='/images/artical.svg' className={styles.artical} />
                                </div>
                                <Typography className={styles.downloadtext}> Grant-In-Aid Program Article in the Independent</Typography>
                            </div>
                        </Grid>
                    </a>
                </div >
            </>
        )
    }

    return (
        <div className={styles.ContactustotalLayout}>
                {contactus()}
           


        </div>
    )
}
export default HumanServicesContactus;